import { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import styles from "./Navbar.module.css";

const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "🧁 Baking", to: "/baking" },
  { label: "💻 Dev Blog", to: "/dev" },
  { label: "⚡ Dev Hacks", to: "/hacks" },
  { label: "About Me", to: "/about" },
];

function LogoMark() {
  return (
    <svg
      width="200"
      height="48"
      viewBox="0 0 200 48"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Code to Crumbs"
      className={styles.logoSvg}
    >
      {/* Icon circle */}
      <circle cx="24" cy="24" r="20" fill="#f5e8d8" />

      {/* C monogram */}
      <text
        x="24"
        y="31"
        fontFamily="'Playfair Display', Georgia, serif"
        fontSize="26"
        fontWeight="700"
        fill="#3d2010"
        textAnchor="middle"
      >
        C
      </text>

      {/* Cookie in the C opening */}
      <circle cx="34" cy="23" r="5.5" fill="#c8895a" />
      <circle cx="32" cy="21" r="1.4" fill="#3d2010" opacity="0.75" />
      <circle cx="35.5" cy="25" r="1.1" fill="#3d2010" opacity="0.6" />
      <circle cx="33" cy="26" r="0.9" fill="#3d2010" opacity="0.5" />

      {/* Crumb scatter */}
      <circle cx="41" cy="14" r="2" fill="#c8895a" opacity="0.5" />
      <circle cx="45" cy="19" r="1.4" fill="#c8895a" opacity="0.35" />

      {/* Vertical divider */}
      <line x1="53" y1="10" x2="53" y2="38" stroke="#e8d4c0" strokeWidth="1" />

      {/* Wordmark */}
      <text
        x="62"
        y="20"
        fontFamily="'Playfair Display', Georgia, serif"
        fontSize="13.5"
        fontWeight="700"
        fill="#2a1508"
        letterSpacing="1.5"
      >
        CODE TO
      </text>
      <text
        x="62"
        y="36"
        fontFamily="'Playfair Display', Georgia, serif"
        fontSize="13.5"
        fontWeight="700"
        fill="#2a1508"
        letterSpacing="1.5"
      >
        CRUMBS
      </text>

      {/* Tagline */}
      <text
        x="62"
        y="46"
        fontFamily="'DM Sans', Arial, sans-serif"
        fontSize="7"
        fontWeight="300"
        fill="#9a7050"
        letterSpacing="1.8"
      >
        from coding to cookies
      </text>
    </svg>
  );
}

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <nav className={styles.nav}>
      <div className={`container ${styles.inner}`}>
        {/* Brand */}
        <Link to="/" className={styles.brand} onClick={() => setOpen(false)}>
          <LogoMark />
        </Link>

        {/* Desktop links */}
        <div className={styles.desktopLinks}>
          {NAV_LINKS.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              end={link.to === "/"}
              className={({ isActive }) =>
                `${styles.navLink} ${isActive ? styles.navLinkActive : ""}`
              }
            >
              {link.label}
            </NavLink>
          ))}
          <Link to="/resume" className={styles.hirePill}>
            Hire Me ✦
          </Link>
        </div>

        {/* Mobile burger */}
        <button
          className={styles.burger}
          onClick={() => setOpen((o) => !o)}
          aria-label="Toggle menu"
        >
          <span
            className={`${styles.burgerIcon} ${open ? styles.burgerOpen : ""}`}
          />
        </button>
      </div>

      {/* Mobile drawer */}
      <div
        className={`${styles.mobileMenu} ${open ? styles.mobileMenuOpen : ""}`}
      >
        {NAV_LINKS.map((link) => (
          <NavLink
            key={link.to}
            to={link.to}
            end={link.to === "/"}
            className={({ isActive }) =>
              `${styles.mobileLink} ${isActive ? styles.mobileLinkActive : ""}`
            }
            onClick={() => setOpen(false)}
          >
            {link.label}
          </NavLink>
        ))}
        <Link
          to="/about"
          className={styles.hirePillMobile}
          onClick={() => setOpen(false)}
        >
          Hire Me ✦
        </Link>
      </div>
    </nav>
  );
}
